module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication"
  }, [_c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "ded"
    }
  }, [_vm._v("To my loving parents and special wife Carole, and my insightful children and awesome grandchildren."), _c('br'), _c('br'), _vm._v("\nWe understood and believed in each other, and that made all the difference.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95233f5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780062046253_epub_ded_r1.vue
// module id = 63
// module chunks = 0